import { inject, Injectable } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { BehaviorSubject, combineLatest, startWith, filter, map, Observable, of, merge } from 'rxjs';
import { ResponseFromExpress } from '../Interfaces/SQL-interfaces';
import { TeudotHistoryResponse } from '../Interfaces/SQL-reports-responses';
import { StoreService } from './store.service';
type TeudotHistoryResponseWithClientId = TeudotHistoryResponse & { ClientId?: string; ISODate?: string };

@Injectable({
	providedIn: 'root',
})
export class DohotBizoimSalesService {
	private fb = inject(FormBuilder);
	private _ss = inject(StoreService);
	form = this.fb.group({
		from: [<Date>new Date(), Validators.required],
		to: [<Date>new Date(), Validators.required],
	});
	rowToScrollTo = 0;
	originalAdminData: TeudotHistoryResponse[] = [];
	adminData: TeudotHistoryResponseWithClientId[] = [];
	adminData$ = new BehaviorSubject<TeudotHistoryResponseWithClientId[]>([]);
	originalAgentData: TeudotHistoryResponse[] = [];
	agentData: TeudotHistoryResponseWithClientId[] = [];
	agentData$ = new BehaviorSubject<TeudotHistoryResponseWithClientId[]>([]);
	HasMultipleCompanies = false;

	datesFilter = [new Date().toISOString().slice(0, 10)];

	dataDisplay$ = combineLatest([
		merge(this.adminData$.asObservable(), this.agentData$.asObservable()),
		this.form.statusChanges.pipe(
			startWith('VALID'),
			filter(status => status === 'VALID'),
		),
	]).pipe(
		map(([data, valid]) => {
			const { from, to } = this.form.value;

			if (!from || !to) return data;

			// console.log(from, to);

			return data.filter(({ ISODate }) => new Date(ISODate) >= from && new Date(ISODate) <= to);
		}),
	);

	constructor() {}

	getAdminTeudot(Company, agents = []): Observable<ResponseFromExpress<TeudotHistoryResponse>> {
		return this._ss.GetAllTeudotAdmin(Company, agents);
	}

	getAgentTeudot() {
		return this._ss.GetAllTeudotAgentNew();
	}

	cleanup() {
		this.rowToScrollTo = 0;
		this.datesFilter = [new Date().toISOString().slice(0, 10)];

		this.adminData = [];
		this.originalAdminData = [];
		this.adminData$.next(this.adminData);

		this.agentData = [];
		this.originalAgentData = [];
		this.agentData$.next(this.agentData);
	}
}
